// Actions for vuex store to be added once we need more complex logic, empty for now
import { Notification } from "element-ui";
import { isMobileDevice } from "@/globals/globals";

export default {
  promptCurrentLocation({ commit }) {

    if(isMobileDevice()) return;

    navigator.permissions.query({ name: 'geolocation' }).then((result) => {if (result.state === 'prompt') {
      Notification({
        title: "Location Access",
        message:
          "Sharing your location allows us to properly locate you when contacting emergency services",
        type: "info",
        duration: 5000
      });
    }})

    return new Promise((resolve) => {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          commit("setLocation", position.coords);
          resolve(position)
        },
        (error) => {
          Notification({
            title: error.message,
            message:
              "Location sharing disabled. This could cause problems with determining your location when in need of emergency services",
            type: "warning",
          });
          resolve(error)
        }
      );
    });
  },
};
